module.exports = __webpack_public_path__ + "static/media/xlm.b27ff885.png";